import { useQuery } from 'react-query';
import eventLogService, { UserLevelActivity } from '../services/eventLog.service';

const useUserLevelActivity = (userIds?: string[], startDate?: string, endDate?: string) => {
  // Only fetch if users are selected
  const userIdParam = userIds?.length ? userIds.sort().join(',') : undefined;

  const { status, data, error, isFetching, refetch } = useQuery<UserLevelActivity>(
    ['userLevelActivity', userIdParam, startDate, endDate],
    () =>
      eventLogService.getUserLevelActivity({
        userId: userIdParam,
        startDate,
        endDate,
      }),
    {
      refetchOnWindowFocus: false,
      enabled: !!userIdParam,
      keepPreviousData: true,
    }
  );

  return {
    status,
    data,
    error,
    isFetching,
    refetch,
  };
};

export default useUserLevelActivity;
